const ActiveMarkerHorizontal = () => (
  <svg
    className="absolute top-16 md:top-6 left-1/2 -translate-x-1/2 w-[30px] h-[16.875px] md:w-[40px] md:h-[22.5px]"
    width="80"
    height="45"
    viewBox="0 0 80 45"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M38.1514 0.936416C39.2234 -0.204931 41.0362 -0.20493 42.1083 0.936416L78.5383 39.7218C80.1659 41.4547 78.9372 44.2944 76.5598 44.2944H3.69984C1.32243 44.2944 0.0937685 41.4547 1.72141 39.7218L38.1514 0.936416Z"
      fill="white"
    />
  </svg>
);

export default ActiveMarkerHorizontal;
